module.exports = __webpack_public_path__ + "img/3-steps.fb37453f.png";